import React from "react";
import { Button, DynamicButton, StyledText } from "../../../../components/common";
import { BackIcon, CloseIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import StarStruckIcon from "../images/star-struck.png";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  img {
    width: 80px;
  }
`;


const CongratsModal = ({ isOpen, onClose = (_) => { }, reward }) => {
  const history = useHistory();
  if (!isOpen) return null;

  const onOkClick = () => {
    history.push('/capturenshare/pickup');
  }

  return (
    <>
      <ModalOverlay onClick={() => { onClose(false) }} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div style={{
          position: "relative",
          width: "100%",
          textAlign: "center"
        }}
        >
          <div
            style={{
              width: 50,
              height: 8,
              backgroundColor: "#cbcbcb",
              borderRadius: 10,
              position: "absolute",
              top: "-5px",
              left: "0%",
              right: "0%",
              margin: "0 auto",
            }}
            onClick={() => { }}
          />

          <StyledText style={{ fontSize: 20, marginTop: "30px", marginBottom: "30px" }}>Congratulations</StyledText>
          <div style={{ maxWidth: "300px", margin: "0 auto" }}>
            <IconContainer>
              <img src={StarStruckIcon} alt="cup" />
            </IconContainer>
            <StyledText style={{ fontFamily: "MTNRegular", marginBottom: "40px" }} size={16}>You’ve won a {reward}! Select an MTN Office near you to have your reward delivered.</StyledText>
            <DynamicButton
              color="#FFCC00"
              textColor="#000"
              label="Set pickup location"
              fullWidth
              onClick={onOkClick}
            />
          </div>
        </div>
      </ModalContent >
    </>
  );
};

export default CongratsModal;
